// firebaseConfig.jsx
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBKQblE2ec8LnddVcAL6Yuwvd4RHYhIHDs",
  authDomain: "tyyabclient.firebaseapp.com",
  databaseURL: "https://tyyabclient-default-rtdb.firebaseio.com",
  projectId: "tyyabclient",
  storageBucket: "tyyabclient.firebasestorage.app",
  messagingSenderId: "816913634288",
  appId: "1:816913634288:web:bc8d0a95ad567cbd834335"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const db = getDatabase(app);
const auth = getAuth(app);
const storage = getStorage(app); // Initialize Firebase storage

export { db, auth, storage };
